import {NgModule} from "@angular/core";
import {SafeHtmlPipe} from "@pipes/safeHtml/safe-html.pipe";
import {HtmlPipe} from "@pipes/html/html.pipe";
import {EllipsisPipe} from '@pipes/ellipsis/ellipsis.pipe';
import { RemoveRMaxPipe } from '@pipes/removeRmax/remove-rmax.pipe';
import { CommonModule } from '@angular/common';


@NgModule({
  declarations: [HtmlPipe, SafeHtmlPipe, EllipsisPipe, RemoveRMaxPipe],
  imports: [
    CommonModule
  ],
  exports: [HtmlPipe, SafeHtmlPipe, EllipsisPipe, RemoveRMaxPipe]
})
export class PipesModule {
}
